<script>
  let { assetsPath = '/', onAiMounted = () => {} } = $props();
  import { onMount } from 'svelte';
  onMount(() => {
    onAiMounted();
  });
</script>

<div id="g-p3_arak-box">
  <!-- Artboard: xs -->
  <div
    id="g-p3_arak-xs"
    class="g-artboard"
    style="display: none;aspect-ratio: 1.23134328358209;"
  >
    <div
      id="g-p3_arak-xs-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/p3_arak-xs.jpg);"
    ></div>
    <div
      id="g-ai0-1"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:3.3885%;margin-top:-11.1px;left:0%;width:143px;"
    >
      <p class="g-pstyle0">Arak nuclear facility</p>
    </div>
    <div
      id="g-ai0-2"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:18.0963%;margin-top:-7.5px;left:9.0945%;width:45px;"
    >
      <p class="g-pstyle1">Arak</p>
    </div>
    <div
      id="g-ai0-3"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:23.6933%;margin-top:-7.5px;left:15.8758%;margin-left:-28px;width:56px;"
    >
      <p class="g-pstyle2">IRAN</p>
    </div>
  </div>

  <!-- Artboard: sm -->
  <div
    id="g-p3_arak-sm"
    class="g-artboard"
    style="display: none;aspect-ratio: 1.29441624365482;"
  >
    <div
      id="g-p3_arak-sm-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/p3_arak-sm.jpg);"
    ></div>
    <div
      id="g-ai1-1"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:2.0764%;margin-top:-11.2px;left:-0.1961%;width:161px;"
    >
      <p class="g-pstyle0">Arak nuclear facility</p>
    </div>
    <div
      id="g-ai1-2"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:14.089%;margin-top:-7.5px;left:5.6922%;width:45px;"
    >
      <p class="g-pstyle1">Arak</p>
    </div>
    <div
      id="g-ai1-3"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:17.8961%;margin-top:-7.5px;left:11.1707%;margin-left:-28px;width:56px;"
    >
      <p class="g-pstyle2">IRAN</p>
    </div>
  </div>

  <!-- Artboard: md -->
  <div
    id="g-p3_arak-md"
    class="g-artboard"
    style="display: none;aspect-ratio: 1.2992125984252;"
  >
    <div
      id="g-p3_arak-md-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/p3_arak-md.jpg);"
    ></div>
    <div
      id="g-ai2-1"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:2.624%;margin-top:-11.3px;left:0%;width:195px;"
    >
      <p class="g-pstyle0">Arak nuclear facility</p>
    </div>
    <div
      id="g-ai2-2"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:14.7797%;margin-top:-9.1px;left:7.4075%;width:49px;"
    >
      <p class="g-pstyle1">Arak</p>
    </div>
    <div
      id="g-ai2-3"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:18.5199%;margin-top:-9.1px;left:12.289%;margin-left:-31px;width:62px;"
    >
      <p class="g-pstyle2">IRAN</p>
    </div>
  </div>
</div>
<!-- End ai2html - 2025-06-19 13:52 -->

<!-- Generated by ai2html v0.101.0 - 2025-06-19 13:52 -->
<!-- ai file: p3_arak.ai -->
<style lang="scss">
  #g-p3_arak-box,
  #g-p3_arak-box .g-artboard {
    margin: 0 auto;
  }
  #g-p3_arak-box p {
    margin: 0;
  }
  #g-p3_arak-box .g-aiAbs {
    position: absolute;
  }
  #g-p3_arak-box .g-aiImg {
    position: absolute;
    top: 0;
    display: block;
    width: 100% !important;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
  }
  #g-p3_arak-box .g-aiPointText p {
    white-space: nowrap;
  }
  #g-p3_arak-box {
    container-type: inline-size;
    @container (min-width:0px) and (max-width: 509px) {
      #g-p3_arak-xs {
        display: block !important;
      }
    }
    @container (min-width:510px) and (max-width: 659px) {
      #g-p3_arak-sm {
        display: block !important;
      }
    }
    @container (min-width:660px) {
      #g-p3_arak-md {
        display: block !important;
      }
    }
  }
  #g-p3_arak-xs {
    position: relative;
    overflow: hidden;
  }
  #g-p3_arak-xs p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 700;
    line-height: 21px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(0, 0, 0);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-p3_arak-xs .g-pstyle0 {
    height: 21px;
  }
  #g-p3_arak-xs .g-pstyle1 {
    font-weight: 400;
    line-height: 14px;
    height: 14px;
    font-size: 12px;
  }
  #g-p3_arak-xs .g-pstyle2 {
    font-weight: 400;
    line-height: 14px;
    height: 14px;
    letter-spacing: 0.2em;
    font-size: 12px;
    text-align: center;
    color: rgb(122, 122, 122);
  }
  #g-p3_arak-sm {
    position: relative;
    overflow: hidden;
  }
  #g-p3_arak-sm p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 700;
    line-height: 21px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 16px;
    text-align: left;
    color: rgb(0, 0, 0);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-p3_arak-sm .g-pstyle0 {
    height: 21px;
  }
  #g-p3_arak-sm .g-pstyle1 {
    font-weight: 400;
    line-height: 14px;
    height: 14px;
    font-size: 12px;
  }
  #g-p3_arak-sm .g-pstyle2 {
    font-weight: 400;
    line-height: 14px;
    height: 14px;
    letter-spacing: 0.2em;
    font-size: 12px;
    text-align: center;
    color: rgb(122, 122, 122);
  }
  #g-p3_arak-md {
    position: relative;
    overflow: hidden;
  }
  #g-p3_arak-md p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 700;
    line-height: 21px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 20px;
    text-align: left;
    color: rgb(0, 0, 0);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-p3_arak-md .g-pstyle0 {
    height: 21px;
  }
  #g-p3_arak-md .g-pstyle1 {
    font-weight: 400;
    line-height: 17px;
    height: 17px;
    font-size: 14px;
  }
  #g-p3_arak-md .g-pstyle2 {
    font-weight: 400;
    line-height: 17px;
    height: 17px;
    letter-spacing: 0.2em;
    font-size: 14px;
    text-align: center;
    color: rgb(122, 122, 122);
  }

  /* Custom CSS */
  .g-text {
  }
</style>
